import React, { useState } from "react";

const API = process.env.REACT_APP_API_BASE_URL || "";

type AffInfo = {
  id: number;
  name: string;
  code: string;
  email?: string;
  createdAt?: string;
};

export default function AffiliateLink() {
  const [input, setInput] = useState("");
  const [info, setInfo] = useState<AffInfo | null>(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const fetchInfo = async () => {
    if (!input.trim()) return alert("IDまたはコードを入力してください");
    setLoading(true);
    try {
      const code = input.trim();
      const r = await fetch(`${API}/api/public/affiliate/${code}`);
      const d = await r.json();
      if (!d || !d.code) {
        alert("該当アフィリエイターが見つかりません");
        setInfo(null);
      } else {
        setInfo(d);
      }
    } catch {
      alert("通信エラー");
    }
    setLoading(false);
  };

  const linkURL = info ? `${window.location.origin}/?aff=${info.code}` : "";
  const copyToClipboard = async () => {
    if (!linkURL) return;
    await navigator.clipboard.writeText(linkURL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ margin: 0, marginBottom: 12, fontWeight: 800 }}>アフィリエイトリンク発行</h2>

      {/* 検索 */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 20 }}>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="アフィリエイトID または コード"
          onKeyDown={(e) => e.key === "Enter" && fetchInfo()}
          style={inputBox}
        />
        <button onClick={fetchInfo} style={btnPrimary}>{loading ? "検索中…" : "検索"}</button>
      </div>

      {/* 結果 */}
      {info && (
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8 }}>
            {info.name}（ID: {info.id}）
          </div>
          <div style={{ fontSize: 14, marginBottom: 8 }}>コード: <b>{info.code}</b></div>
          <div style={{ fontSize: 14, wordBreak: "break-all" }}>
            リンク:
            <a href={linkURL} target="_blank" rel="noopener noreferrer" style={{ color: "#1976d2", marginLeft: 4 }}>
              {linkURL}
            </a>
          </div>
          <button onClick={copyToClipboard} style={{ ...btnPrimary, marginTop: 12 }}>
            {copied ? "コピーしました！" : "リンクをコピー"}
          </button>
        </div>
      )}

      {!info && !loading && (
        <p style={{ color: "#94a3b8", marginTop: 16 }}>アフィリエイトコードを入力して検索してください。</p>
      )}
    </div>
  );
}

const inputBox: React.CSSProperties = {
  flex: 1,
  padding: "10px 12px",
  border: "1px solid #cbd5e1",
  borderRadius: 8,
  background: "#fff",
};

const btnPrimary: React.CSSProperties = {
  padding: "10px 14px",
  borderRadius: 10,
  background: "#1976d2",
  color: "#fff",
  fontWeight: 800,
  border: 0,
};
